import * as actions from './actions'
import reducer from './reducer'
import * as selectors from './selectors'

export * from './models'

const recipients = {
  actions,
  reducer,
  selectors,
}

export default recipients
